
import { Navbar1 } from "components/navbars";
import { Link } from "react-router-dom";
import SalesTrackifyImage from "../assets/images/SalesTrackify.png";

const NotFound = () => {
    return (
        <>
            <Navbar1
                hideSearch
                fixedWidth
                navClass="navbar-light zindex-10"
                buttonClass="btn-outline-secondary btn-sm"
            />

            <div
                className="d-flex align-items-center justify-content-center text-center"
                style={{
                    minHeight: "100vh",
                    background: "linear-gradient(135deg, #f0f4ff 0%, #e0e7ff 50%, #f5f3ff 100%)",
                    position: "relative",
                    overflow: "hidden"
                }}
            >
                {/* Animated Background Elements */}
                <div style={{
                    position: "absolute",
                    top: "10%",
                    left: "5%",
                    width: "300px",
                    height: "300px",
                    background: "radial-gradient(circle, rgba(79, 70, 229, 0.1) 0%, transparent 70%)",
                    borderRadius: "50%",
                    animation: "pulse 4s ease-in-out infinite"
                }} />
                <div style={{
                    position: "absolute",
                    bottom: "15%",
                    right: "8%",
                    width: "250px",
                    height: "250px",
                    background: "radial-gradient(circle, rgba(139, 92, 246, 0.1) 0%, transparent 70%)",
                    borderRadius: "50%",
                    animation: "pulse 4s ease-in-out infinite 1s"
                }} />

                <div className="container position-relative">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10">

                            {/* Floating 404 Image */}
                            <div className="mb-4 position-relative" style={{ maxWidth: "300px", margin: "0 auto" }}>
                                <img
                                    src={SalesTrackifyImage}
                                    alt="404 - Page Not Found"
                                    className="img-fluid"
                                    style={{
                                        maxHeight: "150px",
                                        maxWidth: "100%",
                                        objectFit: "contain",
                                        filter: "drop-shadow(0 20px 40px rgba(79, 70, 229, 0.2))",
                                        animation: "float 4s ease-in-out infinite"
                                    }}
                                />
                              
                            </div>

                            {/* Big 404 Number */}
                            <h1
                                className="display-1 fw-bold mb-2"
                                style={{
                                    fontSize: "clamp(80px, 15vw, 140px)",
                                    fontWeight: "900",
                                    background: "linear-gradient(135deg, #4f46e5 0%, #8b5cf6 100%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    letterSpacing: "-2px",
                                    textShadow: "0 10px 30px rgba(79, 70, 229, 0.3)"
                                }}
                            >
                                404
                            </h1>

                            {/* Heading */}
                            <h2
                                className="fw-bold mb-3"
                                style={{
                                    fontSize: "clamp(1.5rem, 4vw, 2rem)",
                                    color: "#1f2937"
                                }}
                            >
                                Oops! Page Not Found
                            </h2>

                            {/* Description */}
                            <p
                                className="mb-4 mx-auto"
                                style={{
                                    maxWidth: "500px",
                                    color: "#6b7280",
                                    fontSize: "1.1rem",
                                    lineHeight: "1.7"
                                }}
                            >
                                The page you're looking for doesn't exist or has been moved.
                                Let's get you back on track!
                            </p>

                            {/* Action Buttons */}
                            <div className="d-flex flex-wrap justify-content-center gap-3">
                                <Link
                                    to="/"
                                    className="btn btn-lg px-4 py-2 fw-semibold"
                                    style={{
                                        background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                                        border: "none",
                                        borderRadius: "12px",
                                        color: "white",
                                        boxShadow: "0 10px 30px rgba(79, 70, 229, 0.4)",
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    <i className="bi bi-house-door me-2"></i>
                                    Go to Home
                                </Link>
                                <button
                                    onClick={() => window.history.back()}
                                    className="btn btn-lg px-4 py-2 fw-semibold"
                                    style={{
                                        background: "white",
                                        border: "2px solid #e5e7eb",
                                        borderRadius: "12px",
                                        color: "#374151",
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    <i className="bi bi-arrow-left me-2"></i>
                                    Go Back
                                </button>
                            </div>

                            {/* Quick Links */}
                            <div className="mt-5 pt-4">
                                <p className="text-muted mb-3 small">Or explore popular pages:</p>
                                <div className="d-flex flex-wrap justify-content-center gap-2">
                                    <Link to="/features" className="btn btn-sm btn-outline-secondary rounded-pill px-3">
                                        Features
                                    </Link>
                                    <Link to="/contact" className="btn btn-sm btn-outline-secondary rounded-pill px-3">
                                        Contact
                                    </Link>
                                    <Link to="/about" className="btn btn-sm btn-outline-secondary rounded-pill px-3">
                                        About Us
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Custom Styles */}
                <style>
                    {`
                        @keyframes float {
                            0%, 100% { transform: translateY(0px) rotate(0deg); }
                            50% { transform: translateY(-15px) rotate(2deg); }
                        }
                        @keyframes bounce {
                            0%, 100% { transform: translateY(0); }
                            50% { transform: translateY(-10px); }
                        }
                        @keyframes pulse {
                            0%, 100% { opacity: 0.5; transform: scale(1); }
                            50% { opacity: 0.8; transform: scale(1.1); }
                        }
                        .btn:hover {
                            transform: translateY(-3px);
                            box-shadow: 0 15px 40px rgba(79, 70, 229, 0.5) !important;
                        }
                    `}
                </style>
            </div>
        </>
    );
};

export default NotFound;